module.exports = __webpack_public_path__ + "static/media/action-dots.6d2e40ca.svg";